import { API_SendVerificationEmail } from "../../../apis/ApiEmailVerification";
import { useContext, useEffect, useRef, useState } from "react";
import toast from "react-hot-toast";
import { AppContext } from "../../../contexts/AppContext";

export function EmailVerification() {
    const [resent, setResent] = useState<boolean>(false);
    const app = useContext(AppContext);
    const [verified, setVerified] = useState<boolean>(false);
    const timer = useRef<ReturnType<typeof setTimeout>>(null);

    const sendVerificationEmail = async () => {
        setResent(true);
        try {
            const response = await API_SendVerificationEmail();
            if (response)
                toast.success("Email sent successfully.");
            else
                toast.error("Failed to send email.");
        } catch (error) {
            toast.error("Failed to send email.");
        }
    };

    const checkEmailVerification = async () => {
        var res = await app.verifyEmailAuthenticated();
        if (res) {
            setVerified(res);
            clearTimeout(timer.current);
        }
    };

    const getFeatures = async () => {
        if (app?.baseFeatures.UseEmailVerification && !app.loggedInUser.EmailAuthenticated) {
            timer.current = setTimeout(() => {
                getFeatures();
                checkEmailVerification();
            }, 5000);
        }
    }

    useEffect(() => {
        if (!app.loading && !app.loggedInUser.EmailAuthenticated) {
            getFeatures();
        }

        return () => {
            window.clearTimeout(timer?.current);
        };
    }, [app.loading]);


    return (
        <>
            {app?.baseFeatures.UseEmailVerification && !app.loggedInUser.EmailAuthenticated &&
                <div className={`card card-solid-white shadow mb-5`}>
                    <div className="card-body">
                        <div>
                            <h3><i className="fa-solid fa-circle-xmark text-danger"></i> Email verification</h3>
                            <hr className="ShortBlock" />
                        </div>
                        <p>
                            Your email address is not verified. You will not be able to submit an application {app?.baseFeatures.JobAlerts ? 'or subscribe to our job alert service' : ''} if you have not validated the address.
                            If you haven't received the verification email please check your spam folder or click resend verification.
                        </p>
                        <div className="d-flex justify-content-center">
                            <button className="btn btn-outline-alt" disabled={resent} onClick={sendVerificationEmail}>Resend verification</button>
                        </div>
                    </div>
                </div>}
        </>
    );
}